<template>
    <v-dialog
        v-model="isOpen"
        content-class="v-application v-application--is-ltr"
        max-width="580px"
        :fullscreen="!$vuetify.breakpoint.mdAndUp"
    >
        <v-card>
            <v-card-title></v-card-title>
            <v-card-text>
                <v-alert
                    prominent
                    dense
                    outlined
                    color="error"
                    icon="mdi-alert-circle"
                >
                    Freiberufler Storno
                </v-alert>
                <v-row class="pl-3">
                    <v-col cols="auto">
                        <v-checkbox
                            v-model="remove_ma_from_appointment"
                            label="Termine freigeben"
                            hide-details
                        />
                    </v-col>
                </v-row>
                <v-row class="pl-3">
                    <v-col cols="auto">
                        <v-checkbox
                            v-model="send_mail"
                            label="Storno mail senden?"
                            hide-details
                        />
                    </v-col>
                </v-row>
                <v-row v-if="send_mail" class="pl-3">
                    <v-col cols="auto">
                        <v-checkbox
                            v-model="is_cancelled_by_pharmacist"
                            label="Storno vom Freiberufler (wird in der Statistik des Fbs hinterlegt)"
                            class="mt-0"
                            hide-details
                        />
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions class="justify-end">
                <v-btn
                    @click="isOpen = false"
                    outlined
                    color="secondary"
                >
                    Abbrechen
                </v-btn>
                <v-btn
                    @click="onConfirm"
                    color="error"
                    class="confirm-delete-btn"
                    depressed
                >
                    Entfernen
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>


<script>
import { mapMutations } from 'vuex';

export default {
    props: {
        value: Boolean,
    },
    data() {
        return {
            send_mail: false,
            remove_ma_from_appointment: false,
            is_cancelled_by_pharmacist: false
        }
    },
    methods: {
        onConfirm() {
            this.$emit('save', { ...this.$data });
            this.isOpen = false
        },
        reset() {
            for (const key in this.$data) {
                this.$data[key] = false
            }
        },
        ...mapMutations({
            alertError: 'alert/error',
        })
    },
    computed: {
        isOpen: {
            get() {
                return this.value
            },
            set(state) {
                this.$emit('input', state);
                if (!state) this.reset()
            }
        },
    },
    watch: {
        send_mail(sendMail) {
            if (!sendMail) this.is_cancelled_by_pharmacist = false
        }
    },
}
</script>

<style scoped></style>
